import React, { useEffect, useState } from "react";
import { Modal, Alert, Row, Col, Card } from "react-bootstrap";
import Utils from "../../common/Utils";
import _ from "lodash";
import axios from "axios";

const HelpList = (props) => {
  const helps = _.get(props, "data", {});
  const [refreshing, setRefreshing] = useState(false);
  const [showVideo, setShowVideo] = useState("");

  const showHelpRow = (help, idx) => {
    help = help.split("##");
    return (
      <Row key={idx} className="my-3">
        <Col sm={11} className="text-truncate">
          {help[0].substring(0, 100)}
          {/* <iframe src={`https://docs.google.com/viewer?url=${Utils.apiUrl("help/download") + "?fname=" + help[1]}`} width="100%" height="600px"></iframe> */}
        </Col>
        <Col sm={1} className="text-end">
          {help[2] === "link" && (
            <img
              className="clickable"
              height="25"
              title="Click to Play"
              src={`${process.env.PUBLIC_URL}/images/video.png`}
              onClick={() => setShowVideo(help[1])}
            />
          )}
          {help[2] === "upload" && (
            // <a
            //   title="Download"
            //   href={Utils.apiUrl("help/download") + "?fname=" + help[1]}
            // >
            <a title="Download" target="_blank" href={Utils.viewerLink(help[1], `help/download?fname=${help[1]}`)}>
              <img src={Utils.getFileIcon(_.get(help, "1", ""))} height="25" alt="Download" />
            </a>
          )}
          {help[2] === "ext_link" && (
            <a target="_blank" title="Download" href={help[1]}>
              <span>🔗</span>
            </a>
          )}
        </Col>
      </Row>
    );
  };

  const showVideoDialog = () => (
    <Modal size="lg" aria-labelledby="contained-modal-title-vcenter" centered show={showVideo !== ""} onHide={() => setShowVideo("")}>
      <Modal.Header closeButton>
        <Modal.Title id="contained-modal-title-vcenter">Video Help Material</Modal.Title>
      </Modal.Header>
      <Modal.Body>
        <iframe
          height="500"
          width="100%"
          style={{ backgroundColor: "#000" }}
          src={showVideo}
          border="0"
          allowFullScreen
          allow="encrypted-media"
        ></iframe>
      </Modal.Body>
    </Modal>
  );

  return (
    <Modal aria-labelledby="contained-modal-title-vcenter" size="md" centered show={true} onHide={props.onHide}>
      <Modal.Header closeButton>
        <Modal.Title id="contained-modal-title-vcenter">View Help Materials</Modal.Title>
      </Modal.Header>
      <Modal.Body>
        {helps.length === 0 && <Alert variant="danger">No Help Materials</Alert>}

        {helps.map(showHelpRow)}

        {showVideo !== "" && showVideoDialog()}
      </Modal.Body>
    </Modal>
  );
};

export default HelpList;
